@if (dynRemote?.isLoggedIn$.value === false) {
    <div class="dyn-auth-w-body_wrapper">
        <div class="dyn-auth-w-body_container">
            @if (title()) {
                <div class="dyn-auth-w-body_header">
                    {{title() | l10n}}
                </div>
            }
            <div class="dyn-auth-w-body_info">
                {{'Please log in to use this widget.' | l10n}}
            </div>
            <button
                class="dyn-auth-w-body_button"
                (click)="dynRemote.callLogin()">
                Log in
            </button>
        </div>
    </div>
}
